import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import type { RootState } from './rootReducer';

/**
 * The ONE base query every service uses. Duplicating `prepareHeaders` per service is
 * how a slice ends up silently unauthenticated after a token-shape change.
 */
export const makeBaseQuery = (baseUrl: string) =>
  fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, api) => {
      const token = (api.getState() as RootState).auth.token;
      if (token) headers.set('Authorization', `Bearer ${token}`);
      return headers;
    }
  });
